import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {Observable, Subject} from "rxjs/Rx";
import {AuthService} from "./auth.service";


@Injectable()
export class GuestGuard {

  constructor(
    private authService: AuthService,
    private router: Router
    ) {}

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      if (typeof this.authService.isLogged !== 'undefined' && !this.authService.isLogged) {
        return Promise.resolve(true);
      }
      return this.authService.isAuth().toPromise().then((auth) => {
        if (!auth) {
          return Promise.resolve(true);
        }
        this.router.navigateByUrl('/company/select');
        return Promise.resolve(false);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guest.guard.ts